// extracted by mini-css-extract-plugin
module.exports = {"container":"Content_container__vAkUW","tabItem":"Content_tabItem__17iiK","row":"Content_row__BSQPp","image":"Content_image__1zefK"};